module.exports = __webpack_public_path__ + "static/media/Img_card_REITs.11c2d45a.jpg";